import React, { useState, useEffect } from 'react'

import {
  Close,
  Minus,
  Plus
} from 'src/components/svgs'

import {
  useUpdateItemsFromCart,
  useRemoveItemFromCart,
  client
} from 'src/context/siteContext'

export const LineItem = ({ id, title, quantity, variant, customAttributes }: {
  id: string
  title: string
  quantity: number
  variant: {
    price: string
    image: string
    compareAtPrice: string
  }
  customAttributes: Array<{
    value: string
  }>
}) => {
  const updateItemsFromCart = useUpdateItemsFromCart()

  const [stateQuantity, setQuantity] = useState(quantity)
  const removeFromCart = useRemoveItemFromCart()

  const updateQuantity = (qty: number) => {
    updateItemsFromCart({id, quantity: qty})
    setQuantity(qty)
  }

  const itemImage = client.image.helpers.imageForSize(
    variant.image,
    { maxWidth: 300, maxHeight: 300 }
  )

  return (
    <div className='f x aist rel cart__single'>
      <div className='cart__single-image mr1'>
        <img className='x' src={itemImage} alt={title} />
      </div>
      <div className='f jcb cart__col'>
        <div>
          <span className='s1 caps m0 p0'>{title}</span><br />
          {!/Default Title/.test(variant.title) && (
            <span className='s1 caps'>{variant.title}</span>
          )}
        </div>
        <div className='f jcs ais al cw product__form-qty-wrapper mt05 '>
          <button className='block rel s1 qty__control no-style mr1 pr1 cw cursor  aic' onClick={() => stateQuantity === 1 ? null : updateQuantity(stateQuantity - 1)}>-</button>
          <span type='number' name='quantity' min='1' className='cw s1 ml05 mr05 card-qty bn ac'>{stateQuantity}</span>
          <button className='qty__control no-style s1 block f jcc aic founders s24 cursor rel py05 jcc aic' onClick={() => updateQuantity(stateQuantity + 1)}>+</button>
          <div className='abs right cart__single-price s16 bottom py1'>
            {variant.compareAtPrice && (
              <span className='strikethrough s1 caps'>
                ${parseFloat(variant.compareAtPrice) * stateQuantity} ({stateQuantity})
              </span>
            )}
            <span className='s1 caps'>
              ${parseFloat(variant.price) * stateQuantity} ({stateQuantity})
            </span>
          </div>
        </div>
        <button type='reset' className='p05 abs no-style close right top cw' onClick={() => removeFromCart(id)}>
          <Close className='block' />
        </button>
      </div>
    </div>
  )
}